import React from 'react';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_RESOURCES } from 'routes';

import { Box, Container, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';
import Button from '@libs/ui/components/button';
import Typography, { OuterLink } from '@libs/ui/components/typography';

interface TextBlockProps extends React.PropsWithChildren<unknown> {
  job: Job;
  text?: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(10, 6),
    backgroundColor: '#FAFAFA',
  },
  form: {
    maxWidth: 256,
  },
}));

const TextBlock = ({ job, children, text }: TextBlockProps) => {
  const classes = useStyles();
  const { t } = useTranslation('public');

  return (
    <Container maxWidth={false} className={classes.root}>
      <Box pb={6}>
        <Typography textAlign="center" variant="h5">
          {t('jobDetails.footer.somethingForYou')}
        </Typography>
      </Box>

      <Grid container justifyContent="center">
        <Grid className={classes.form} item>
          <Button
            type="submit"
            size="large"
            color="primary"
            variant="contained"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            fullWidth
          >
            {t('jobDetails.footer.applyToday')}
          </Button>
        </Grid>
      </Grid>

      <Box pt={6} margin="0 auto" maxWidth={840}>
        <Typography paragraph fontWeight={600} variant="h6" textAlign="center">
          {t('jobDetails.footer.aboutUs')}
        </Typography>
        <Typography paragraph textAlign="center">
          {t('jobDetails.footer.aboutUsText')}
        </Typography>
        <Typography textAlign="center">
          {t('jobDetails.footer.hireTalent')}{' '}
          <OuterLink href={EXTERNAL_RESOURCES.companiesLanding}>
            {t('jobDetails.footer.learnHow')}
          </OuterLink>
        </Typography>
      </Box>
    </Container>
  );
};

export default TextBlock;
